import { supabase } from '../supabaseClient';

export const sendAppointmentEmail = async (app, emailInput) => {
  const details = app.study_details || {};
  
  const filesHtml = details.attached_files?.length > 0 
    ? `<ul>${details.attached_files.map(f => `
        <li style="margin-bottom: 10px;">
          <a href="${f.url}" style="color: #1a73e8; font-weight: bold; text-decoration: none; background: #e8f0fe; padding: 5px 10px; border-radius: 5px; display: inline-block;">
            📄 Abrir ${f.name}
          </a>
        </li>`).join('')}</ul>`
    : details.attached_files_count > 0 
      ? `<p><em>Tiene ${details.attached_files_count} archivos adjuntos.</em></p>`
      : '<p>Sin archivos adjuntos.</p>';

  const htmlContent = `
    <div style="font-family: sans-serif; max-width: 600px; border: 1px solid #eee; padding: 20px; border-radius: 10px;">
      <h2 style="color: #1a73e8; border-bottom: 2px solid #1a73e8; padding-bottom: 10px;">Expediente de Turno - GDT</h2>
      
      <div style="margin-bottom: 20px;">
        <h3 style="color: #444;">Datos del Paciente</h3>
        <p><strong>Nombre:</strong> ${app.patient_name}</p>
        <p><strong>DNI:</strong> ${details.patient_dni || 'No especificado'}</p>
        <p><strong>Fecha de Nac.:</strong> ${details.patient_birthdate || 'No especificada'}</p>
        <p><strong>Teléfono:</strong> ${app.patient_phone || 'No especificado'}</p>
      </div>

      <div style="margin-bottom: 20px; background: #f8f9fa; padding: 15px; border-radius: 8px;">
        <h3 style="color: #444; margin-top: 0;">Detalles del Turno</h3>
        <p><strong>Estudio:</strong> ${app.study_type || 'Consulta'}</p>
        <p><strong>Fecha:</strong> ${app.appointment_date}</p>
        <p><strong>Hora:</strong> ${app.appointment_time?.substring(0, 5)} hs</p>
        <p><strong>Obra Social:</strong> ${details.insurance_provider || 'PARTICULAR'}</p>
        <p><strong>Plan:</strong> ${details.insurance_plan || 'N/A'}</p>
      </div>

      <div style="margin-bottom: 20px;">
        <h3 style="color: #e67e22;">Archivos Adjuntos (${details.attached_files_count || 0})</h3>
        ${filesHtml}
      </div>
      
      <div style="text-align: center; margin: 30px 0; padding: 20px; background: #e3f2fd; border-radius: 10px;">
        <h3 style="color: #1565c0; margin-top: 0;">¿Confirma su asistencia?</h3>
        <p style="color: #666; margin-bottom: 20px;">Haga clic en el botón correspondiente para confirmar su turno o si necesita modificarlo.</p>
        <div style="display: flex; justify-content: center; gap: 10px; flex-wrap: wrap;">
          <a href="https://jlm-agency.com/GDT/#/confirmar-turno/${app.id}?action=confirm" style="background: #1a73e8; color: white; padding: 12px 25px; text-decoration: none; border-radius: 8px; font-weight: bold; font-size: 16px; display: inline-block; margin: 5px;">CONFIRMAR TURNO</a>
          <a href="https://jlm-agency.com/GDT/#/confirmar-turno/${app.id}?action=modify" style="background: #e53935; color: white; padding: 12px 20px; text-decoration: none; border-radius: 8px; font-weight: bold; font-size: 16px; display: inline-block; margin: 5px;">NO CONFIRMAR O MODIFICAR</a>
        </div>
      </div>

      <p style="color: #666; font-size: 0.9rem; border-top: 1px solid #eee; padding-top: 15px;">
        Este es un reporte automático generado desde la plataforma GDT.
      </p>
    </div>
  `;

  const { error } = await supabase.functions.invoke('resend', {
    body: {
      to: emailInput,
      subject: `Confirmar Turno: ${app.patient_name} - GDT`,
      html: htmlContent
    }
  });

  if (error) throw new Error(error.message);
  return true;
};
